import DateFnsUtils from "@date-io/date-fns";
import { Container } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider
} from "@material-ui/pickers";
import "date-fns";
import MaterialTable from "material-table";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
// eslint-disable-next-line
import { getSessionData } from "../../base/helper/baseHelper";
import LandingPageFooter from "../../LandingPage/views/LandingPageFooter";
import { getPhysicalInventoryReportWithoutLotNo } from "../helper/reportHelper";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiPaper-root": {
      backgroundColor: "rgba(255,255,255,0.5)",
      backdropFilter: "blur(6px)",
      borderRadius: "15px",
      padding: "10px",
      marginTop: "1%",
      justifyContent: "center",
      alignItems: "center",
      widht: "100%",
    },
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  container: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    marginBottom: theme.spacing(2),
    borderRadius: "5px",
    backgroundColor: "rgba(255,255,255,0.5)",
    backdropFilter: "blur(8px)",
  },
}));

function PhysicalInventoryReportWithoutLotNo(props) {
  const classes = useStyles();

  const [userId, setUserId] = useState("");
  const [storeId, setStoreId] = useState("");
  const [fromDate, setFromDate] = React.useState(new Date());
  const [toDate, setToDate] = React.useState(new Date());
  const [gridData, setGridData] = React.useState([]);

  useEffect(() => {
    setUserId(getSessionData({ key: "userId" }));
    const store = JSON.parse(getSessionData({ key: "store" }));
    setStoreId(store.storeid);
    // eslint-disable-next-line
  }, [userId, storeId]);

  const handleFromDateChange = (date) => {
    setFromDate(date);
  };

  const handleToDateChange = (date) => {
    setToDate(date);
  };

  const loadReport = (e) => {
    var fDate = new Date(fromDate);
    var strFromDate =
      fDate.getFullYear() +
      "/" +
      (fDate.getMonth() + 1) +
      "/" +
      fDate.getDate();

    var tDate = new Date(toDate);
    var strToDate =
      tDate.getFullYear() +
      "/" +
      (tDate.getMonth() + 1) +
      "/" +
      tDate.getDate();

    getPhysicalInventoryReportWithoutLotNo(
      userId,
      storeId,
      strFromDate,
      strToDate
    )
      .then((response) => {
        if (response && response.length > 0) {
          setGridData(response);
        } else {
          setGridData([]);
        }
      })
      .catch((err) => {});
  };

  return (
    <Container maxWidth={false}>
      <CssBaseline />
      <Grid container spacing={3} style={{ marginTop: "1.5%" }}>
        <Grid item xs={12} sm={4}>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <Grid justify="space-between">
              <KeyboardDatePicker
                autoFocus
                autoOk={true}
                okLabel={""}
                cancelLabel={""}
                margin="normal"
                id="fromDate"
                label="From Date"
                format="MM/dd/yyyy"
                value={fromDate}
                onChange={handleFromDateChange}
                className={classes.submit}
                fullWidth
                KeyboardButtonProps={{
                  "aria-label": "change date",
                }}
              />
            </Grid>
          </MuiPickersUtilsProvider>
        </Grid>
        <Grid item xs={12} sm={4}>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <Grid justify="space-around">
              <KeyboardDatePicker
                margin="normal"
                id="toDate"
                label="To Date"
                format="MM/dd/yyyy"
                autoOk={true}
                okLabel={""}
                cancelLabel={""}
                value={toDate}
                onChange={handleToDateChange}
                className={classes.submit}
                fullWidth
                KeyboardButtonProps={{
                  "aria-label": "change date",
                }}
              />
            </Grid>
          </MuiPickersUtilsProvider>
        </Grid>
        <Grid item xs={12} sm={4}>
          <Button
            onClick={(e) => {
              loadReport(e);
            }}
            fullWidth={true}
            color="primary"
            variant="contained"
            size="medium"
            style={{
              marginTop: "5%",
              backgroundColor: "rgb(22, 177, 255)",
              borderRadius: "0.5rem",
            }}
          >
            Generate
          </Button>
        </Grid>
      </Grid>
      <div className={classes.root}>
        <MaterialTable
          title=""
          columns={[
            {
              title: "Description",
              field: "description",
              cellStyle: { width: "20%" },
            },
            { title: "Location", field: "location" },
            { title: "NDC", field: "ndc" },
            { title: "UPC", field: "upc" },
            { title: "Pack Size", field: "packsize" },
            { title: "Manufacturer", field: "manufacturer" },
            { title: "Full Qty", field: "fullquantity" },
            { title: "Partial Qty", field: "partialquantity" },
          ]}
          data={gridData}
          options={{
            maxBodyHeight: 670,
            paging: true,
            pageSize: 25,
            pageSizeOptions: [25, 50, 100],
            headerStyle: {
              backgroundColor: "rgba(255,255,255,1)",
              color: "black",
            },
            exportButton: true,
            exportAllData: true,
          }}
        />
      </div>
      <LandingPageFooter />
    </Container>
  );
}

const mapStateToDispatch = (state) => ({});

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToDispatch,
  mapDispatchToProps
)(PhysicalInventoryReportWithoutLotNo);
